import { render, staticRenderFns } from "./EditOrderItemSchedule.vue?vue&type=template&id=81aedde0"
import script from "./EditOrderItemSchedule.vue?vue&type=script&lang=js"
export * from "./EditOrderItemSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports